export const SET_CURENCY = 'NEW_SELLER/SET_CURRENCY';
export const SET_MARGIN = 'NEW_SELLER/SET_MARGIN';
export const SET_ASSET = 'NEW_SELLER/SET_ASSET';
export const SET_LOCATION = 'NEW_SELLER/SET_LOCATION';
export const SET_PAYMENT_METHODS = 'NEW_SELLER/SET_PAYMENT_METHODS';
export const SET_CONTACT_INFO = 'NEW_SELLER/SET_CONTACT_INFO';
export const SET_ARBITRATOR = 'NEW_SELLER/SET_ARBITRATOR';
export const SET_LIMITS = 'NEW_SELLER/SET_LIMITS';
